var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNetworkMed = function SvgNetworkMed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 550 701"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#89898b",
    stroke: "#707070",
    d: "M449.5.5a49.847 49.847 0 0 0-50 50v600a49.847 49.847 0 0 0 50 50h50a49.847 49.847 0 0 0 50-50v-600a49.847 49.847 0 0 0-50-50Z",
    "data-name": "Path 7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8c400",
    d: "M249.5 150.5a49.847 49.847 0 0 0-50 50v450a49.847 49.847 0 0 0 50 50h50a49.847 49.847 0 0 0 50-50v-450a49.847 49.847 0 0 0-50-50Z",
    "data-name": "Path 8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f8c400",
    d: "M99.5 301h-50A49.347 49.347 0 0 0 0 350.5v300A49.347 49.347 0 0 0 49.5 700h50a49.347 49.347 0 0 0 49.5-49.5v-300A49.347 49.347 0 0 0 99.5 301",
    "data-name": "Path 9"
  })));
};
export default SvgNetworkMed;